(ns ui.dialog
  (:require ["@radix-ui/react-dialog" :as RadixDialog]
            [lucide-react :refer [X]]
            [ui.utils :refer [clsx separate-props]]
            [ui.button :as button]))

(defn dialog-title [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixDialog/Title (-> props
                                    (dissoc :truncate)
                                    (update :class #(clsx "text-xl leading-8 font-medium break-words pr-10"
                                                          {"truncate" (:truncate props)}
                                                          %)))]
          children)))

(defn dialog-title-bg [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (update :class #(clsx "flex justify-between items-center py-4 pl-6 pr-16 -mx-6 -mt-4 bg-kleene-background-secondary z-10"
                                          %)))]
          children)))

(defn dialog-description [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixDialog/Description (update props :class #(clsx "text-sm mt-1" %))]
          children)))

(defn dialog-trigger [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixDialog/Trigger (-> {:as-child true
                                       :data-slot "dialog-trigger"}
                                      (merge props))]
          children)))

(defn dialog-close [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixDialog/Close (-> {:as-child true}
                                    (merge props))]
          children)))

(defn dialog-close-x [props]
  [dialog-close {:data-cy "dialog-close-btn"
                 :data-slot "dialog-close"
                 :asChild true}
   [:div (-> props
             (update :class #(clsx "absolute top-4 right-6 z-2000" %)))
    [button/button {:icon    X
                    :variant :empty
                    :size    :icon}]]])

(defn dialog-content [& args]
  (let [[props children] (separate-props args)
        x-close          (if (contains? props :x-close) (:x-close props) true)
        size             (or (:size props) :small)
        no-padding       (:no-padding props)
        overlay-class    (:overlay-class props)]
    [:> RadixDialog/Portal {:data-slot "dialog-portal"
                            :force-mount (:force-mount props)}
     [:> RadixDialog/Overlay {:data-slot "dialog-overlay"
                              :class (clsx "bg-black/50 fixed inset-0 isolate z-2000" overlay-class)}]
     (when (false? (:modal props))
       [:div {:class "bg-black/50 fixed inset-0 z-2000 transition-all" :data-slot "dialog-backdrop"}])

     (into
      [:> RadixDialog/Content
       (-> {:data-slot "dialog-content"
            :aria-describedby js/undefined ;; supresses console warning
            }
           (merge props)
           (dissoc :no-padding :force-mount :modal :x-close :overlay-class)
           (update :class #(clsx "overflow-hidden fixed grid top-1/2 left-1/2 -translate-x-1/2 max-h-[calc(100vh-2rem)] -translate-y-1/2 outline-none p-4 z-2000
                                  bg-kleene-background rounded-lg shadow-2xl transition-all overflow-y-auto"
                                 {"px-6 py-4" (not no-padding)}
                                 (case size
                                   :small  "max-w-lg w-full"
                                   :smallish "max-w-2xl w-full"
                                   :medium "max-w-4xl w-full"
                                   :large  "max-w-7xl w-full"
                                   :full   "translate-none h-auto inset-4"
                                   (js/console.error "Unknown dialog size: " size))
                                 %)))
       (when x-close
         [dialog-close-x])]
      children)]))

(defn dialog-actions [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (update :class #(clsx "flex mt-4 gap-2 items-center justify-end" %)))]
          children)))

(defn dialog-root [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixDialog/Root (-> {:data-slot "dialog"}
                                   (merge props))]
          children)))

(defn dialog [{:keys [open on-open-change title description content x-close content-props content-wrapper-class root-props actions actions-props]
               :or   {content-props {}
                      root-props    {}
                      x-close       true}}
              trigger]
  [dialog-root (merge root-props
                      {:open           open
                       :on-open-change on-open-change
                       :aria-describedby (when-not description js/undefined)})
   (when trigger
     [dialog-trigger trigger])

   [dialog-content content-props
    (when title [dialog-title title])
    (when description [dialog-description description])
    [:div {:class content-wrapper-class} content]
    (when actions
      [dialog-actions actions-props
       actions])
    (when x-close
      [dialog-close-x])]])
